<rt-collapsible-card
  rtCollapsibleCardAnalytics
  analyticsKey="details"
  uniqKey="candidate-details-card"
  [hasHeaderDivider]="true"
>
  <div leftSlot layout layout-align-items-center>
    <rt-heading>
      {{ 'app.candidate.details' | translate }}
    </rt-heading>
  </div>

  <div collapsible layout-full-width padding-tb-small-xx>
    <rt-candidate-field-row-simple
      [name]="'app.candidate.details_card.date_created' | translate"
      [fieldDisplayTpl]="dateCreatedTpl"
    />
    <rt-candidate-field-row-simple
      [name]="'app.candidate.details_card.source' | translate"
      [fieldDisplayTpl]="sourceTpl"
    />
    <rt-candidate-field-row-simple
      [name]="'app.candidate.details_card.last_activity' | translate"
      [fieldDisplayTpl]="lastActivityTpl"
    />
  </div>
</rt-collapsible-card>

<ng-template #dateCreatedTpl>
  <div layout layout-wrap>
    <div [rtTooltip]="candidate().createdAt | amDateFormat: 'lll'">
      {{ candidate().createdAt | amDateFormat: 'll' }} ({{
        candidate().createdAt | rtTimeAgo | lowercase
      }})
    </div>
    <rt-divider variant="dot" />

    <div>
      @switch (candidate()!.source) {
        @case (CandidateSource.CareerSite) {
          <span layout-horizontal layout-align-items-center>
            {{
              'app.candidate.details_card.applied_via_careers_site'
                | translate
                  : {
                      language: applyLanguage()?.hasLanguages
                        ? $safeNavigationMigration(applyLanguage()?.desc)
                        : '',
                    }
            }}
          </span>
        }

        @case (CandidateSource.Email) {
          <span layout-horizontal layout-align-items-center>
            {{ 'app.candidate.applied' | translate }}
            @if (candidate().referrer) {
              <span margin-left-small-xx> via {{ candidate().referrer }} </span>
            }
          </span>
        }

        @case (CandidateSource.Manual) {
          <span layout-horizontal layout-align-items-center>
            {{ 'app.candidate.added_manually_by' | translate }}
            @if (candidate().admin && !candidate().admin.anonymizedAt) {
              <span margin-left-small-xx>
                {{ candidate().admin.firstName }} {{ candidate().admin.lastName }}
              </span>
            }
            @if (!candidate().admin || candidate().admin.anonymizedAt) {
              <span margin-left-small-xx>
                {{ 'app.common.deleted_user' | translate }}
              </span>
            }
            @if (candidate().referrer) {
              <span margin-left-small-xx> via {{ candidate().referrer }} </span>
            }
          </span>
        }

        @case (CandidateSource.Import) {
          <span layout-horizontal layout-align-items-center>
            {{ 'app.candidate.imported_from' | translate }}
            {{ (candidate().sourcingOrigin! | rtSourceName) || candidate().referrer }}
            @if (candidate().admin) {
              <span>
                &nbsp;{{ 'app.common.by' | translate }}
                <span> {{ candidate().admin.firstName }} {{ candidate().admin.lastName }} </span>
              </span>
            }
          </span>
        }
        @case (CandidateSource.Referral) {
          <span layout-horizontal layout-align-items-center>
            @if (candidateReferrers()?.hasReferrers) {
              <span [rtTooltip]="candidateReferrers().tooltip">
                {{ candidateReferrers().desc }}
              </span>
            }
          </span>
        }
      }
    </div>
  </div>
</ng-template>
<ng-template #sourceTpl>
  <rt-candidate-sources-container
    [withHeading]="false"
    [withEmptyState]="true"
    [hasNoMargin]="true"
  />
</ng-template>
<ng-template #lastActivityTpl>
  <span margin-right-small-x no-shrink>
    {{ candidate().lastActivityAt | rtTimeAgo }}
  </span>
  @if (lastActivity()) {
    <rt-activity-item
      [activity]="lastActivity()!"
      [shortMessage]="true"
      [isSmall]="true"
      [hasSmallAvatar]="true"
      [hasNoPadding]="true"
      [withTime]="false"
      [displayContent]="false"
      [fontWeightDefault]="true"
      [displayInline]="true"
      [canManageCandidates]="canManageCandidates()"
      [showNewTriggeredIcon]="hasWorkflowAutomations()"
    />
  }
</ng-template>
